export default function DisclaimerFooter() {
  return (
    <footer className="flex-none border-t border-trading-border bg-trading-panel/80 px-3 py-1.5 z-10">
      <p className="text-[10px] text-trading-muted leading-snug text-center">
        <span className="font-semibold text-trading-muted/80">【免責事項】</span>{' '}
        本プロジェクトは教育・娯楽・情報提供のみを目的としており、実際の取引・投資を目的としたものではありません。
        財務・投資・税務・法律に関する助言ではなく、正確性・完全性・適合性について一切の保証をしません。
        出力結果が不正確・不完全・古い可能性があります。作成者および貢献者はいかなる金銭的損失または損害に対しても一切責任を負いません。
        投資判断を行う前に資格のあるファイナンシャルアドバイザーにご相談ください。過去の実績は将来の結果を示すものではありません。
        本ソフトウェアを使用することにより、学習および情報収集のみの目的で使用することに同意し、その使用に伴うすべてのリスクを受け入れるものとします。
      </p>
      <p className="text-[10px] text-trading-muted/60 text-center mt-0.5">
        © {new Date().getFullYear()}{' '}
        <a
          href="https://lafine.net/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-trading-muted transition-colors"
        >
          Lafine Systems Design.
        </a>{' '}
        All rights reserved.
      </p>
    </footer>
  )
}
